import { render, staticRenderFns } from "./ExercisesDefaultList.vue?vue&type=template&id=8aa15f80&lang=pug"
import script from "./ExercisesDefaultList.vue?vue&type=script&lang=js"
export * from "./ExercisesDefaultList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports